<template>
  <div>
    <div class="index_banner-out">
      <!-- <div class="swiper-container banner-container">
        <div class="swiper-wrapper banner-wrapper">
          <div class="swiper-slide banner-slide banner-slide_3" > -->
            <!-- <a href="/static/images/01-1.png"></a> -->
            <!-- <img src="/static/images/n_banner.jpg" /> -->
            <!-- <div class="banner-slide-img-768"></div> -->
          <!-- </div> -->
          <!-- <div class="swiper-slide banner-slide banner-slide_2"> -->
            <!-- <video
              class="a-j banner-slide-video-768"
              autoplay="autoplay"
              loop="loop"
              muted="muted"
              style="height: 958px"
            >
              <source
                :src="this.config.imgServer + 'zy68.mp4'"
                type="video/mp4"
              />
            </video> -->
          <!-- </div> -->
        <!-- </div>
      </div> -->
       <div class="swiper-slide banner-slide banner-slide_3" ></div>
      <!--登录START-->
      <div
        class="banner_log_on wow fadeIn"
        data-wow-duration="0.8s"
        data-wow-delay="0.2s"
        v-if="sendsystem"
      >
        <login-form ref="login" @on-success-valid="handleSubmit"></login-form>
      </div>
      <div
        class="banner_log_on wow fadeIn"
        data-wow-duration="0.8s"
        data-wow-delay="0.2s"
        v-else
      >
        <div class="container">
          <ul class="banner_log_on_list row">
            <!--<li-->
            <!--class="col-lg-4 col-sm-4 col-xs-12 wow fadeInDown"-->
            <!--data-wow-duration="0.4s"-->
            <!--data-wow-delay="0.3s"-->
            <!--&gt;欢迎：{{realname}}</li>-->
            <li
              class="
                col-md-offset-2 col-lg-4 col-sm-offset-2 col-sm-4 col-xs-12
                wow
                fadeInDown
              "
              data-wow-duration="0.4s"
              data-wow-delay="0.3s"
            >
              <input
                class="into"
                type="button"
                @click="EntrySystem()"
                value="进入系统"
                placeholder
              />
            </li>
            <li
              class="col-lg-4 col-sm-4 col-xs-12 wow fadeInDown"
              data-wow-duration="1.2s"
              data-wow-delay="0.3s"
            >
              <input
                class="logout"
                type="button"
                @click="Cancellation()"
                value="注销"
                placeholder
              />
            </li>
          </ul>
        </div>
      </div>
      <!--登录END-->
    </div>
    <!-- <logincomponents></logincomponents> -->
    <!----------- 服务项目 ---------->
    <!-- <div class="index_title_out">
      <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      >
      <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          PROJECT
          <em>●</em> 服务项目
        </strong>
      </h4>
      <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p>
    </div>
    <div class="index_service_out container">
      <ul class="WOW index_service_list row">
        <li
          class="col-lg-3 col-md-3 col-sm-12 col-xs-12 wow fadeInUp"
          data-wow-duration="0.4s"
          data-wow-delay="0.3s"
          v-for="sitem in Server" :key="sitem.id"
        >
          <a target="_blank" @click="newsClick(sitem.id)">
            <div class="list_con">
              <div class="img">
                <img :src="sitem.img" alt />
              </div>
              <div class="txt">
                <h6 class="font-title">{{ sitem.title }}</h6>
                <p class="font-text">{{ sitem.subTitle | ellipsis }}</p>
              </div>
            </div>
          </a>
        </li>
        <li class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <a target="_blank" href="http://ks.sdzzdzkj.com">
            <div class="list_con">
              <div class="img">
                <img src="/static/images/service-img.png" alt />
              </div>
              <div class="txt">
                <h6 class="font-title">全国医学检验大赛作品展示</h6>
                <p class="font-text">
                  深入推进信息技术与医学检验技术专业在临床与教学的深度融合，展示医学检验技术专业信息化建设成果。
                </p>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div> -->
    <!----------- 服务项目 end ---------->
    <!----------- 公司介绍 ---------->
    <!-- <div class="index_title_out font-note"> -->
      <!-- <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      > -->
      <!-- <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          ABOUT US
          <em>●</em> 学校简介
        </strong>
      </h4> -->
      <!-- <p class="wow fadeInDown " data-wow-duration="0.8s" data-wow-delay="0.4s">
        内蒙古医科大学成立于1956年
        <br />学校前身为内蒙古医学院
      </p> -->
    <!-- </div>
    <div class="index_about_out">
      <div class="container">
        <div
          class="index_about_txt wow zoomIn"
          data-wow-duration="0.5s"
          data-wow-delay="0.4s"
          style="text-align: left"
        >
          <p style="text-align: left">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;内蒙古医科大学成立于1956年，是新中国在民族地区最早建立的高等医学院校之一，学校前身为内蒙古医学院，当时隶属于国家卫生部，1958年划归内蒙古自治区管理。2012年，更名为内蒙古医科大学。2017年，成为内蒙古自治区人民政府、国家卫生计生委、教育部共建高校。67年来，为国家培养各级各类人才10万余名，为自治区经济发展、社会进步、科技创新、文化传承、民族团结、边疆稳定做出了重要贡献，已成为一所具有区域特色的多科性医科大学。
          </p>
          <p style="text-align: left">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学校坐落于内蒙古自治区首府呼和浩特市，设有金山校区（主校区）、新华校区、锡林校区及红山口教学基地。总占地面积123.19万平方米，总建筑面积为52.69万平方米。教学科研仪器设备总值为8.61亿元，图书馆馆藏印本文献126.65万册，有中外文数据库67个、电子图书33.27万种、电子期刊25.77万种。学校设有17个学院，12个临床医学院，3所直属附属医院，在区内外设有实践教学基地99个。有全日制在校生16266人。
            其中，本科生12047人、专科生（高职）744人、博士研究生36人、硕士研究生3116人、留学生54人，民族预科生80人，本科各专业面向国内29个省、市、自治区招生。
          </p>
          <p style="text-align: left">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学校自1956年开始招收本科生，1978年开始招收研究生，1981年获得硕士学位授权资格，1999年获得同等学力人员申请硕士学位的授权资格，2018年获批成为博士学位授予单位。现有1个博士学位授权一级学科，9个硕士学位授权一级学科，7个硕士专业学位授权类别，有博士生导师49人，硕士生导师823人。
          </p>
          <a target="_blank" @click="about()">
            <img :src="this.config.imgServer + 'img-4.png'" alt />
          </a>
        </div> -->
        <!-- <ul class="row index_about_list">
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="0.4s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">7</dt>
              <dd>年虚拟仿真实验经验</dd>
            </dl>
          </li>
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="0.8s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">45</dt>
              <dd>名高精尖专业技术团队</dd>
            </dl>
          </li>
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="1.2s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">150</dt>
              <dd>余所高等医学院校的选择</dd>
            </dl>
          </li>
          <li>
            <dl
              class="wow fadeInDown"
              data-wow-duration="1.6s"
              data-wow-delay="0.4s"
            >
              <dt class="counter">240</dt>
              <dd>多个医学虚拟仿真实验</dd>
            </dl>
          </li>
        </ul> -->
      <!-- </div>
    </div> -->
    <!----------- 公司介绍 end ---------->
    <!----------- 核心优势 ---------->
    <!-- <div class="index_title_out">
      <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      >
      <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          technology
          <em>●</em> 核心优势
        </strong>
      </h4>
      <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p>
    </div>
    <div class="index_technology_out container">
      <ul class="index_technology_list row">
        <li
          class="a col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="0.4s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>轻量级架构</h6>
              <span></span>
              <p>
                三层开发模式，使用<br />
                Asp.Net(C#)编程语言<br />
                保持轻量级架构。
              </p>
            </div>
          </div>
        </li>
        <li
          class="b col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>响应式管理界面</h6>
              <span></span>
              <p>
                界面设计友好，使用<br />
                响应式设计全面兼容<br />
                IE8及主流浏览器。
              </p>
            </div>
          </div>
        </li>
        <li
          class="c col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="1.2s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>可拔插插件</h6>
              <span></span>
              <p>
                支持可插拔插件，使<br />
                整个系统扩展起来更<br />
                加简单。
              </p>
            </div>
          </div>
        </li>
        <li
          class="d col-lg-3 col-sm-6 col-xs-6 wow fadeInUp"
          data-wow-duration="1.6s"
          data-wow-delay="0.2s"
        >
          <div class="con">
            <div class="icon">
              <em></em>
            </div>
            <div class="txt">
              <h6>功能自定义</h6>
              <span></span>
              <p>
                用户可以按需求在后台<br />
                创建自己需要的频道功<br />
                能及功能模块。
              </p>
            </div>
          </div>
        </li>

      </ul>
    </div> -->
    <!----------- 核心优势 end ---------->
    <!----------- 新闻资讯 ---------->
    <!-- <div class="index_title_out"> -->
      <!-- <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      > -->
      <!-- <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          News
          <em>●</em> 新闻资讯
        </strong>
      </h4> -->
      <!-- <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p> -->
    <!-- </div>
    <div class="index_news_out">
      <div class="container">
        <div
          class="recommend_out col-lg-6 col-sm-12 col-xs-12 wow fadeInLeft"
          data-wow-duration="1s"
          data-wow-delay="0.4s"
        >
          <div v-for="onew in newsOne">
            <a target="_blank" @click="newsClick(onew.id)" class="recommend">
              <div class="img">
                <img :src="onew.img" alt />
              </div>
              <div class="txt">
                <h6>{{ onew.title }}</h6>
                <span>{{ $moment(onew.pubDate).format("YYYY-MM-DD") }}</span>
                <p>{{ onew.subTitle | ellipsis }}</p>
              </div>
            </a>
          </div>
        </div>
        <ul
          class="list col-lg-6 col-sm-12 col-xs-12 wow fadeInRight"
          data-wow-duration="1s"
          data-wow-delay="0.4s"
        >
          <li v-for="newitem in NewsAndIAnformation">
            <a target="_blank" @click="newsClick(newitem.id)">
              <dl class="time">
                <dt>{{ newitem.pubDate | dayData }}</dt>
                <dd>{{ newitem.pubDate | yearData }}</dd>
              </dl>
              <dl class="list_con">
                <dt>{{ newitem.title }}</dt>
                <dd>{{ newitem.subTitle | ellipsis }}</dd>
              </dl>
            </a>
          </li>
        </ul>
      </div>
      <div class="more">
        <a target="_blank" @click="list()">查看更多新闻</a>
      </div>
    </div> -->
    <!----------- 新闻资讯 end ---------->
    <!----------- 合作院校 ---------->
    <!-- <div class="index_title_out"> -->
      <!-- <span class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.4s"
        >SHANDONG &nbsp;&nbsp; ZEZHONG</span
      > -->
      <!-- <h4>
        <strong
          class="wow fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.4s"
        >
          cooperate
          <em>●</em> 合作院校
        </strong>
      </h4> -->
      <!-- <p class="wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.4s">
        凭借过硬的专业知识和高质量服务标准，提供全方位、
        <br />高质量、专业化的医学虚拟仿真教学实验
      </p> -->
    <!-- </div> -->
    <!--滚动结束 -->
    <!-- <div class="index_cooperate_out">
      <div class="swiper-container index_cooperate_container">
        <div class="swiper-wrapper index_cooperate_wrapper">
     <vue-seamless-scroll
    :data="schoolList"
    :class-option="classOption"
    class="warp"
  >
    <ul class="ul-item">
      <li class="li-item swiper-slide index_cooperate_slide" v-for="(schoolitem, index) in schoolList" :key="index" >
        <img :src="schoolitem.Logo" alt />
       <div class="zz">
              <h6>{{ schoolitem.SchoolName }}</h6>
              <p>{{ schoolitem.content }}</p>
            </div>
      </li>
    </ul>
  </vue-seamless-scroll></div>
        <div class="swiper-button-next index_cooperate_button-next"></div>
        <div class="swiper-button-prev index_cooperate_button-prev"></div>
    </div></div> -->
    <!--滚动开始 -->
    <!-- <div class="index_cooperate_out">
      <div class="swiper-container index_cooperate_container">
        <div class="swiper-wrapper index_cooperate_wrapper">
          <div
            class="swiper-slide index_cooperate_slide"
            v-for="schoolitem in schoolList"
            @click="schoolurl(schoolitem.Url)"
          >
            <img :src="schoolitem.Logo" alt />
            <div class="zz">
              <h6>{{ schoolitem.SchoolName }}</h6>
              <p>{{ schoolitem.content }}</p>
            </div>
          </div>
        </div>
        <div class="swiper-button-next index_cooperate_button-next"></div>
        <div class="swiper-button-prev index_cooperate_button-prev"></div>
      </div>
    </div> -->
    <!-- 重置密码后强制修改密码才能登录 -->
      <Modal
        v-model="isShowChangePwd"
        title="修改密码">
        <Alert type="error" style="margin-bottom:15px">密码已经重置，请先修改密码，再次登录</Alert>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
        <FormItem label="原密码：" prop="passWord">
            <Input v-model="formValidate.passWord" autocomplete="new-password"  type="text" placeholder="请输入原密码"></Input>
        </FormItem>
        <FormItem label="新密码：" prop="OnePassword">
            <Input v-model="formValidate.OnePassword" type="password" autocomplete="new-password" placeholder="请输入新密码"></Input>
        </FormItem>
        <FormItem label="再次输入：" prop="TwoPassword">
            <Input v-model="formValidate.TwoPassword" type="password" autocomplete="new-password" placeholder="请再次输入新密码"></Input>
        </FormItem>
        </Form>
        <div slot="footer">
          <Button type="text" size="large" @click="isShowChangePwd=false">取消</Button>
          <Button type="primary" size="large" @click="submitChangePwd">确定</Button>
       </div>
        <!-- <div class="container">
        <ul class="row personal_modify_list">
          <li >
            <div >
              <span >
                <i>*</i>
                <em>原密码：</em>
              </span>
              <div class="input">
                <input v-model="passWord" type="text" placeholder />
              </div>
            </div>
          </li>
          <li >
            <div class="">
              <span >
                <i>*</i>
                <em>新密码：</em>
              </span>
              <div class="input col-lg-8">
                <input v-model="OnePassword" type="password" placeholder />
              </div>
            </div>
          </li>
          <li class="col-lg-12">
            <div class="con col-lg-7 col-md-6 col-sm-12 col-xs-12">
              <span class="col-lg-4">
                <i>*</i>
                <em>再次输入：</em>
              </span>
              <div class="input col-lg-8">
                <input v-model="TwoPassword" type="password" placeholder />
              </div>
            </div>
          </li>
        </ul>
      </div> -->
    </Modal>

  </div>
</template>
<script>
import { jquery } from "jquery";
import "bootstrap";
import { WOW } from "wowjs";
import Swiper from "../../static/js/swiper.min.js";
import "../../static/js/nav.js";
import "../../static/js/jquery.aniview.js";
import "../../static/js/jquery.waypoints.min.js";
import "../../static/js/jquery.countup.min.js";
import "../../static/js/public.js";
import "../../static/css/swiper.min.css";
import "../../static/css/nav.css";
import "../../static/css/animate.min.css";
import "../../static/css/common.css";
import "../../static/css/style.css";
import Qs from "qs";

import LoginForm from "@/components/loginForm/loginForm.vue";
import md5 from "js-md5";
import moment from "moment";

import axios from "@/libs/api.request";

import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 80) {
        return value.slice(0, 80) + "...";
      }
      return value;
    },
    yearData(value) {
      return moment(value).format("YYYY-MM");
    },
    dayData(value) {
      return moment(value).format("DD");
    },
  },
  // 验证密码

  data() {
    let regPass = /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,18}$/;
    let validatorPass = (rule, value, callback) => {
    if (!value) {
          callback(new Error('请输入新密码'));
      } else if (!regPass.test(value)) {
          callback(new Error('密码必须至少含有数字和字母，区分大小写，长度为6-18位'));
      } else {
          callback();
      }
  };
  let validateComfirmPass = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请再次输入新密码'));
        } else if (value !== this.formValidate.OnePassword) {
          callback(new Error('两次输入新密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      classOption: {
        limitMoveNum: 2,
        direction: 3,
      },
      //服务项目
      Server: [],
      //核心优势
      CoreStrengths: [],
      //第一条新闻
      newsOne: {},
      //新闻资讯
      NewsAndIAnformation: [],
      //合作院校
      schoolList: [],
      sendsystem: true,
      realname: "",
      isShowChangePwd:false,
      formValidate:{
        passWord:'',
        OnePassword:'',
        TwoPassword:'',
      },
      ruleValidate:{
        passWord: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        OnePassword: [ {required: true, validator: validatorPass, trigger: 'blur' }],
        TwoPassword: [ {required: true, validator: validateComfirmPass, trigger: 'blur' }],
      }
    }
  },
  components: {
    // logincomponents,
    LoginForm,
    vueSeamlessScroll,
  },
  methods: {
    submitChangePwd(){
      this.$refs.formValidate.validate((valid) => {
        if(valid) {
        let data={
          NewPwd : md5(this.formValidate.OnePassword),
          OldPwd : md5(this.formValidate.passWord)
        }
        console.log(data)
        var posturl =this.config.baseUrl.pro + "/User/UpdatePwd";
          axios.request({
              url: posturl,
              method: "post",
              data: Qs.stringify(data),
              headers: {
                authToken: localStorage.getItem("authToken"),
                account: localStorage.getItem("account"),
                accept: "text/plain",
              },
            }).then((resp) => {
              if (resp.data.result.code === 1) {
                // localStorage.clear();
                this.isShowChangePwd=false;
                this.$refs.login.form.password="";
                this.$Message.success('密码修改成功，请重新登录！');
              }
            })
            .catch((err) => {
              this.$Message.error("修改密码失败！");
              console.log(err);
            });
          }
      })
    },
    cclick() {
      console.log(2);
      window.open("/static/images/山东泽众电子科技有限公司招聘文件.pdf", '_blank');
    },
    //注销
    Cancellation() {
      var Signout = localStorage.getItem("Signout");
      var url = localStorage.getItem("url");
      localStorage.clear();
      localStorage.setItem("Signout", Signout);
      localStorage.setItem("url", url);
      this.sendsystem = true;
    },
    //进入系统
    EntrySystem() {
      // var sendurl =
      //   localStorage.getItem("url") + localStorage.getItem("sendurl");
      var sendurl = "/" + localStorage.getItem("sendurl");
      console.log(sendurl);
      window.location.href = sendurl;
    },
    //登录
    handleSubmit({ userName, password }) {
      var posturl = this.config.baseUrl.pro + "/login/apiLogin";
      password = md5(password);
      userName = userName.trim();
      let postdata = {
        User_Name: userName,
        Secretkey: password,
        rememberClient: true,
      };
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: Qs.stringify(postdata),
        })
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            var data = resp.data.result;
            if (data.success) {
              console.log("新闻站登录：");
              console.log(resp);
              if(data.data.user.isReset==1){
                localStorage.setItem("userid", data.data.user.id);
                localStorage.setItem("authToken", data.token);
                localStorage.setItem("account", data.data.user.user_Name);
                this.isShowChangePwd=true
              }else{
                localStorage.setItem("userid", data.data.user.id);
                localStorage.setItem("authToken", data.token);
                localStorage.setItem("account", data.data.user.user_Name);
                localStorage.setItem("realname", data.data.user.real_Name);
                localStorage.setItem("systype", data.data.sysType);
                localStorage.setItem("sendurl", data.data.url);
                localStorage.setItem("UserRoleId", data.data.user.role_Id);
                localStorage.setItem("department_Id", data.data.user.department_Id);
                localStorage.setItem("className", data.data.user.className);
                localStorage.setItem("isReset", data.data.user.isReset);
                localStorage.setItem("baseUrl", GlobalVariable.BaseUrl);
                // localStorage.setItem(
                //   "facecheckapiUrl",
                //   this.$config.baseUrl.facecheckapiUrl
                // );
                localStorage.setItem("iS_Complete", data.data.user.iS_Complete);
                this.sendsystem = false;
                this.getConfig();
              }
            } else {
              // this.$Message.error("登录失败，用户名或密码错误");
              this.$Modal.error({
                title: "提示",
                content: "登录失败，" + data.message,
              });
              console.log(data.message);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    schoolurl(src) {
      if (src != null && src !== "#") {
        window.open(src);
      }
    },
    ///登录状态判断
    loginStatus() {
      var sendurl = localStorage.getItem("sendurl");
      var token = localStorage.getItem("authToken");
      if (
        sendurl !== null &&
        sendurl !== undefined &&
        sendurl !== "" &&
        token !== null &&
        token !== undefined &&
        token !== ""
      ) {
        this.sendsystem = false;
        this.realname = localStorage.getItem("realname");
        this.getConfig();
      } else {
        this.Cancellation();
      }
    },
    getConfig() {
      var posturl = this.config.baseUrl.pro + "/Base_Config/apiGetConfigLoad";
      return axios
        .request({
          url: posturl,
          method: "POST",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlenCoded",
            authToken: localStorage.getItem("authToken"),
            accept: "text/plain",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            var data = resp.data.Result.Data;
            console.log(data);
            for (var i = 0; i < data.length; i++) {
              var item = data[i];
              localStorage.setItem(item.Code, item.Value);
              localStorage.removeItem("TeacherEnCode");
              localStorage.removeItem("TeacherEnCodes");
              localStorage.removeItem("StudentEnCode");
              localStorage.removeItem("StudentEnCodes");
            }
          } else {
            localStorage.clear();
            this.loginStatus();
          }
        })
        .catch((err) => {
          localStorage.clear();
          this.loginStatus();
          console.log(err);

          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    getNewsData() {},
    ///数据加载
    getData() {
      let data = [
        { type: "Server", name: "Server", start: 0, num: 3, rec: 0 },
        {
          type: "CoreStrengths",
          name: "CoreStrengths",
          start: 0,
          num: 4,
          rec: 0,
        },
        {
          type: "NewsAndIAnformationOne",
          name: "NewsAndIAnformationOne",
          start: 0,
          num: 1,
          rec: 1,
        },
        {
          type: "NewsAndIAnformation",
          name: "NewsAndIAnformation",
          start: 1,
          num: 4,
          rec: 1,
        },
      ];
      var posturl =
        this.config.baseUrl.pro + "/Base_News/ApiIndexLoadBase_NewsCompany";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域2
          data: data,
        })
        .then((resp) => {
          if (resp.status === 200) {
            //这里进行赋值
            var list = resp.data.result;
            console.log(list);
            for (var i = 0; i < list.length; i++) {
              if (list[i].newslist != null && list[i].newslist.length > 0) {
                if (list[i].name === "Server") {
                  try {
                    this.Server = list[i].newslist;
                  } catch (e) {
                    console.log(e);
                  }
                } else if (list[i].name === "CoreStrengths") {
                  this.CoreStrengths = list[i].newslist;
                } else if (list[i].name === "NewsAndIAnformationOne") {
                  this.newsOne = list[i].newslist;
                } else if (list[i].name === "NewsAndIAnformation") {
                  this.NewsAndIAnformation = list[i].newslist;
                }
              }
            }
          }
        })
        .catch((err) => {
          this.$Message.info("数据请求失败");
        });
    },
    ///新闻的点击
    newsClick(id) {
      let routeData = this.$router.resolve({
        path: "details",
        query: { id: id },
      });
      window.open(routeData.href, "_blank");
    },
    about() {
      let routeData = this.$router.resolve({ path: "about" });
      window.open(routeData.href, "_blank");
    },
    list() {
      let routeData = this.$router.resolve({ path: "newslist" });
      window.open(routeData.href, "_blank");
    },
    dataUp(datas) {
      for (var i = 0; i < datas.length; i++) {
        try {
          var datetime = new Date(datas[i].createDate);
          datas[i].yearAndMonth =
            datetime.getFullYear() + "-" + datetime.getMonth();
          datas[i].day = datetime.getDay();
          datas[i].img = this.config.imgServer + "/img-1.png";
        } catch (e) {
          console.log(i + "--" + e);
        }
      }
      return datas;
    },
    schoolData() {
      var posturl =
        this.config.baseUrl.pro +
        "/Base_PartnerSchool/GetBase_AllPartnerSchool";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域2
        })
        .then((resp) => {
          var data = resp.data.Result;
          console.log(data.length);
          for (var s = 0; s < data.length; s++) {
            data[s].Logo = "http://sdzzdzkj.com/" + data[s].Logo;
          }
          this.schoolList = data;
        })
        .catch((err) => {
          console.log(err);
          this.$Message.info("数据请求失败");
        });
    },
    swLoad() {
      var that = this;
      that.$nextTick(function () {
        var mySwiper = new Swiper(".index_cooperate_container", {
          observer: true,
          loop: true,
          direction: "horizontal" /*横向滑动*/,
          pagination: ".swiper-pagination" /*分页器*/,
          autoplay: {
            delay: 1000, //1秒切换一次
          },
          navigation: {
            nextEl: ".index_cooperate_button-next",
            prevEl: ".index_cooperate_button-prev",
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1000: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1366: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
            1500: {
              slidesPerView: 6,
              spaceBetween: 50,
            },
          },
        });
      });
      new Swiper(".index_cooperate_container", {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: true,
        loop: true,
        navigation: {
          nextEl: ".index_cooperate_button-next",
          prevEl: ".index_cooperate_button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1000: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1366: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
          1500: {
            slidesPerView: 6,
            spaceBetween: 50,
          },
        },
      });
    },
  },
  mounted() {
    this.loginStatus();
    this.getData();

    this.schoolData();
    this.swLoad();

  },
  watch: {
    cases() {
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true,
      });
      wow.init();
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.warp {
  width: 130px * 4;
  height: 120px;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
      .li-item {
        width: 120px;
        height: 120px;
        margin-right: 10px;
        line-height: 120px;
        background-color: #999;
        color: #fff;
        text-align: center;
        font-size: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue